import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChatFillIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 10.1538C23 8.65771 21.7666 7.43994 20.25 7.43994H6V16.7261C6 18.2222 7.2334 19.4399 8.75 19.4399H19.0776L23 22.0015V10.1538ZM10.5 14.9399C11.3284 14.9399 12 14.2684 12 13.4399C12 12.6115 11.3284 11.9399 10.5 11.9399C9.67157 11.9399 9 12.6115 9 13.4399C9 14.2684 9.67157 14.9399 10.5 14.9399ZM14.5 14.9399C15.3284 14.9399 16 14.2684 16 13.4399C16 12.6115 15.3284 11.9399 14.5 11.9399C13.6716 11.9399 13 12.6115 13 13.4399C13 14.2684 13.6716 14.9399 14.5 14.9399ZM20 13.4399C20 14.2684 19.3284 14.9399 18.5 14.9399C17.6716 14.9399 17 14.2684 17 13.4399C17 12.6115 17.6716 11.9399 18.5 11.9399C19.3284 11.9399 20 12.6115 20 13.4399Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M3.75 2C2.2334 2 1 3.21777 1 4.71387V15.6953L3 14H4.5V12V5.96H16V2H3.75Z",
    fill: "currentColor"
  }));
}